export const ActionSubmitBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-mouse" viewBox="0 0 16 16">
      <path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3m4 8a4 4 0 0 1-8 0V5a4 4 0 1 1 8 0zM8 0a5 5 0 0 0-5 5v6a5 5 0 0 0 10 0V5a5 5 0 0 0-5-5"/>
    </svg>
    <div class="gjs-block-label">${label}</div>`,
    category: category,
    content: `
    <button class="btn btn-primary" type="button" data-gjs-type="${type}" data-gjs="${type}" data-gjs-custom-name="${label}" onclick="actionSubmit(event)">Submit</button>`,
  });
};
export default async (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId } = config;

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-mouse"></i>',
          projectId,
          resizable: true,
          traits: [
            {
              type: 'webconnect-event',
              label: 'Create Event',
              name: 'data-oncreate',
            },
            {
              type: 'select',
              label: 'Create Method',
              name: 'data-createmethod',
              default: 'POST',
              options: [
                { value: 'POST', name: 'POST' },
                { value: 'PUT', name: 'PUT' },
              ],
            },
            {
              type: 'webconnect-event',
              label: 'Update Event',
              name: 'data-onupdate',
            },
            {
              type: 'select',
              label: 'Update Method',
              name: 'data-updatemethod',
              default: 'PUT',
              options: [
                { value: 'POST', name: 'POST' },
                { value: 'PUT', name: 'PUT' },
              ],
            },
            ...defaultModel.prototype.defaults.traits,
          ],
        },
        init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
};
